import { IAddToCartTray } from '@models/IAddToCartTray';
import { IBasketQuantityChangeResponse } from '@models/IBasket';
import axios from 'axios';

export const addItemToCart = async (
  endpoint: string,
  productData: { code: string; quantity: number }
) => {
  const { data } = await axios.post<IAddToCartTray>(
    endpoint,
    JSON.stringify(productData),
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );

  return data;
};

export const removeItemFromCart = async (
  endpoint: string,
  code: string,
  isGift?: boolean
) => {
  const { data } = await axios.post<IBasketQuantityChangeResponse>(endpoint, {
    code,
    isGift,
  });

  return data;
};

export const changeCartItemQuantity = async (
  endpoint: string,
  productData: { code: string; quantity: number }
) => {
  const { data } = await axios.post<IBasketQuantityChangeResponse>(
    endpoint,
    productData
  );

  return data;
};

export const changeVoucher = async (endpoint: string, voucher: string) => {
  const formData = new FormData();
  formData.append('couponCode', voucher);

  await axios.post(endpoint, formData);
};

export const refresh = async <T>(endpoint: string, from?: string) => {
  const [pathname = '', queryString = ''] = endpoint.split('?');
  const urlSearchParams = new URLSearchParams(queryString);
  if (from) urlSearchParams.set('from', from);

  const updatedQueryString = urlSearchParams.toString();
  const updatedEndpoint = updatedQueryString
    ? `${pathname}?${updatedQueryString}`
    : pathname;

  const { data } = await axios.get<T>(updatedEndpoint);
  return data;
};
